<!-- 推广账户管理 - 腾讯 -->
<template>
<div>
	<div style="display: flex;align-items: center;">
		<div v-for="(item,index) in titleTab" :key="index" 
		:class="{'title-tab-box-selected': item.select}" 
		@click="changeTab(item,index)"
		class="title-tab-box">{{item.label}}</div>
	</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 15px 0 0;">
		<div v-show="content_type == 0 || content_type == 2" class="screen-box">
			<div class="screen-label">账户名称</div>
			<a-input v-model="r_account_name" allowClear placeholder="请输入" style="width: 200px;"  />
		</div>
		
		<div v-show="content_type == 0 || content_type == 2" class="screen-box">
			<div class="screen-label">负责人</div>
			<adminSelect @handleChangeSelect="handleChangeF"></adminSelect>
		</div>
		
		<div v-show="content_type == 0 || content_type == 2" class="screen-box">
			<div class="screen-label">账户ID</div>
			<a-input v-model="r_account_id" allowClear placeholder="请输入" style="width: 200px;"  />
		</div>
		
		<div class="screen-box">
			<div class="screen-label">账户平台</div>
			<a-select style="width: 160px;" 
			 @change="handleChangeA" allowClear placeholder="请选择" 
			 :getPopupContainer="getsPopupContainer">
				<a-select-option value="1">MP</a-select-option>
				<a-select-option value="2">ADQ</a-select-option>
			</a-select>
		</div>
		
		<a-button @click="searchButton('button')" :loading="search_button_loading" class="screen-box" type="primary" icon="search">搜索</a-button>
		<a-button v-show="content_type == 0 || content_type == 2" @click="showPlAccID()" class="screen-box" type="primary">批量搜索账户ID</a-button>
		<a-button v-show="content_type == 0 || content_type == 2" class="screen-box" @click="setFZR" type="primary">批量设置负责人（已选{{selectedData.length}}项）</a-button>
		
		<a-button v-show="content_type == 0 || content_type == 2" @click="addButton" class="screen-box" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增授权账户</a-button>
	</div>
	
	<div v-show="content_type == 0 || content_type == 2">
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div class="table-th-cell"
			:style="{'width':50 + 'px'}">
				<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				v-if="item.show_control"
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<!-- 选择 -->
			<div class="table-td-cell" :style="{'width':50 + 'px'}">
				<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
			</div>
			<!-- ID -->
			<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
				{{item.id}}
			</div>
			<!-- 授权账户ID -->
			<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
				{{item.account_id}}
			</div>
			<!-- 授权账户名称 -->
			<div class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
				{{item.account_name}}
			</div>
			<!-- 操作 -->
			<!-- <div @click="editTable(index,item)" class="table-td-cell" :style="{'width': rableTitle[2].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
				同步推广计划
			</div> -->
			<!-- 账户平台 -->
			<div class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
				<!-- ADQ或MP两个取值，根据微信账户ID是否为空判断，为空则ADQ -->
				<div v-if="item.wechat_account_id">MP</div>
				<div v-else>ADQ</div>
			</div>
			<!-- 微信账号Id -->
			<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
				{{item.wechat_account_id}}
			</div>
			<!-- 负责人 -->
			<div @click="editFZR(item)" class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}" >
				<div v-if="Object.keys(item.admin_user).length > 0" style="display: flex;align-items: center;cursor: pointer;flex-wrap: wrap;">
					<div v-for="(value,key) in item.admin_user" :key="key" style="color: #2F88FF;margin: 0 10px 5px 0;">
						{{value}}
					</div>
				</div>
				<div v-else style="color: #62a8ea;cursor: pointer;">
					未设置
				</div>
				
				<!-- <div v-if="item.admin_name" style="color: #2F88FF;cursor: pointer;">
					{{item.admin_name}}
				</div>
				<div v-else style="color: #62a8ea;cursor: pointer;">
					未设置
				</div> -->
			</div>
			<!-- 授权账户 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
				<div v-if="item.adv">{{item.adv.account_name}}</div>
				
			</div>
			<!-- 授权账户身份类型 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[7].width + 'px'}">
				{{item.account_role_type}}
			</div>
			<!-- 账户类型 -->
			<!-- <div  class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
				{{item.account_type}}
			</div> -->
			<!-- 授权人角色 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[8].width + 'px'}">
				{{item.role_type}}
			</div>
			<!-- 同步代理商MP或者ADQ -->
			<div v-show="rableTitle[9].show_control" class="table-td-cell" :style="{'width':rableTitle[9].width + 'px'}">
				<div @click="syncMpAdq(item)" style="color: #62a8ea;cursor: pointer;">同步推广账户</div>
			</div>
		</div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_scroll_width"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	<div v-show="content_type == 1">
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width_d + 'px'}">
			<div  v-for="(item,index) in rableTitleDDD" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowDataDDD" :key="index" class="table-td"  :style="{'width': table_scroll_width_d + 'px'}">
			<!-- 开发者账户名称 -->
			<div class="table-td-cell" :style="{'width':rableTitleDDD[0].width + 'px'}">
				{{item.account_name}}
			</div>
			<!-- 应用ID -->
			<div  class="table-td-cell" :style="{'width':rableTitleDDD[1].width + 'px'}">
				{{item.client_id}}
			</div>
			<!-- Secret -->
			<div  class="table-td-cell" :style="{'width':rableTitleDDD[2].width + 'px'}">
				{{item.secret}}
			</div>
			<!-- 创建时间 -->
			<div  class="table-td-cell" :style="{'width':rableTitleDDD[3].width + 'px'}">
				{{item.created_at}}
			</div>
			<!-- 更新时间 -->
			<div  class="table-td-cell" :style="{'width':rableTitleDDD[4].width + 'px'}">
				{{item.updated_at}}
			</div>
		</div>
		
		<div v-show="tableShowDataDDD.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width_d + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<div style="text-align: center;margin-top: 30px;" :style="{'width': table_scroll_width_d + 'px'}">
			
			<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total_ddd" @change="paginationChange" />
			
		</div>
	</div>
	
	<!-- 编辑单项的弹窗 -->
	<a-modal
	      title="编辑负责人"
	      :visible="edit_visible"
	      :confirm-loading="confirmLoading"
		  cancelText="取消"
		  okText="确认" 
	      @ok="editModalOk"
	      @cancel="editModalCancel"
	    >
		<a-select
			mode="multiple" 
			style="min-width: 300px"
			placeholder="请选择负责人"
			@change="handleChangeD"
			:filter-option="filterOption"
			:getPopupContainer="getsPopupContainer"
			:value="edit_fzr"
		  >
			<a-select-option v-for="(value,key) in personChargeList" :key="key" :value="key">
			  {{value}}
			</a-select-option>
		</a-select>
	</a-modal>
	
	<!-- 批量设置负责人 -->
	<a-modal :visible="pl_modal" title="批量设置负责人" okType="primary" width="700px"
	  okText="设置" cancelText="取消"
	  @ok="plOk" @cancel="plCancel" :confirmLoading="pl_loading">
	    <div style="">
			<div style="display: flex;align-items: center;">
				<div style="margin-right: 15px;font-size: 15px;">请选择要添加的负责人</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择负责人"
					@change="handleChangeE"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					:labelInValue="true"
				  >
					<a-select-option v-for="(value,key) in personChargeList" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
			</div>
			<div style="display: flex;flex-wrap: wrap;margin: 15px 0 30px;max-height: 100px;overflow-y: auto;">
				<div style="width: 120px;display: flex;align-items: center;margin-bottom: 7px;" v-for="(item,index) in pl_select_admin" :key="index">
					<div style="margin-right: 15px;">{{item.label}}</div>
					<!-- <div @click="delSelectFZR(index)" style="color: red;cursor: pointer;">删除</div> -->
					<a-icon @click="delSelectFZR(index)" type="close-circle" />
				</div>
			</div>
			<div style="margin-bottom: 10px;margin-top: 15px;">已选的推广账户名称：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
					<div style="width: 70px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 190px;">{{item.account_name}}</div>
				</div>
			</div>
			
			<!-- <div class="">id：4 —— 李永润</div> -->
		</div>
	</a-modal>
	
	<!-- 批量搜索账户ID -->
	<plSearchID ref="refPlSearchID" @get-pl-id="getPlId"></plSearchID>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import plSearchID from "./components/plSearchID"
import adminSelect from "./components/adminSelect"
import { putUserList, accAgentList, accAgentEditFZR, accAgentAccountList, accAgentSyncMpAdq } from '@/request/api'
export default {
	name: 'accountTX_',
	components: {
		plSearchID,adminSelect
	},
	data() {
		return {
			titleTab: [
				{label: "推广账户管理", select: true , value: 0 },
				{label: "代理商账户列表", select: false , value: 2 },
				{label: "开发者账户管理", select: false , value: 1 },
			],
			content_type: 0, // 页面内容展现类型
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", show_control: true, },
				{title:"推广账户ID", width:100, type:"account_id", show_control: true, },
				{title:"推广账户名称", width:180, type:"account_name", show_control: true, },
				// {title:"操作", width:120, type:"cz", show_control: true, },
				{title:"账户平台", width:80, type:"", show_control: true, },
				{title:"微信账号Id", width:150, type:"wechat_account_id", show_control: true, },
				{title:"负责人", width:100, type:"admin_name", show_control: true, },
				{title:"授权账户", width:150, type:"adv", show_control: true, },
				{title:"授权账户身份类型", width:150, type:"account_role_type", show_control: true, },
				// {title:"账户类型", width:100, type:"account_type", show_control: true, },
				{title:"授权人角色", width:150, type:"role_type", show_control: true, },
				{title:"同步推广账户", width:150, type:"", show_control: false, },
			],
			tableShowData: [],
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_scroll_width: 1000,
			table_scroll_width_d: 1000,
			search_button_loading: false,
			table_total: 0,
			r_page: 1,
			r_limit: 100,
			r_account_name: "", // 账户名称
			r_account_id: "", // 代理商账户ID
			r_is_wechat_account: undefined, // MP或ADQ
			r_admin_id: null, // 负责人id
			
			personChargeList: {}, // 负责人列表
			edit_visible: false, // 编辑弹窗的显示
			confirmLoading: false,
			edit_fzr: undefined, // 负责人参数
			e_ids: "", // 选择的表格id
			
			d_page: 1,
			rableTitleDDD: [
				{title:"开发者账户名称", width:180, type:"account_name", },
				{title:"应用ID", width:150, type:"client_id", },
				{title:"Secret", width:200, type:"secret", },
				{title:"创建时间", width:200, type:"created_at", },
				{title:"更新时间", width:200, type:"updated_at", },
			],
			tableShowDataDDD: [],
			table_total_ddd: 0,
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selectedData: [], // 选择内容存放数组
			
			// 批量设置负责人
			pl_modal: false,
			pl_loading: false,
			pl_select_admin: [],
			
			// 批量搜索账户ID
			pl_account_visible: false, // 批量搜索账户ID
			pl_text_content: [], // 批量粘贴过来，分隔过后的数据
			pl_acc_input: "", 
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		let table_info = this.$getTableInfo(that.rableTitle)
		let table_info_c = this.$getTableInfo(that.rableTitleDDD)
		that.table_scroll_width = table_info.table_width - 30 // 这30是两边的内边距
		that.table_scroll_width_d = table_info_c.table_width - 30
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		// 负责人
		putUserList().then(res=>{
			console.log("负责人",res);
			that.personChargeList = res.data.data.list
		})
		
		
		that.searchButton()
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		handleChangeA(e){
			console.log(e);
			this.r_is_wechat_account = e
		},
		// 负责人
		handleChangeF(e){
			this.r_admin_id = e
		},
		changeTab(e,index){
			console.log(e);
			// 如果已经是选中状态就没必要再执行一次了
			if(!this.titleTab[index].select){ 
				this.content_type = e.value
				this.titleTab.forEach(res=>{
					res.select = false
				}) 
				this.titleTab[index].select = true
				
				this.r_account_name = "" // 推广账户名称 或 代理商账户名称
				this.r_account_id = "" // 推广账户ID 或 代理商账户ID
				
				this.r_page = 1
				this.searchButton()
			}
			
		},
		searchButton(type){
			let that = this
			that.search_button_loading = true
			if(that.content_type == 0 || that.content_type == 2){
				let ttt = "ACCOUNT_ROLE_TYPE_ADVERTISER" // 表示广告主
				if(that.content_type == 2){
					ttt = "ACCOUNT_ROLE_TYPE_AGENCY" // 代理商
					that.rableTitle[1].title = "代理商账户ID"
					that.rableTitle[2].title = "代理商账户名称"
				}
				else if(that.content_type == 0){
					that.rableTitle[1].title = "推广账户ID"
					that.rableTitle[2].title = "推广账户名称"
				}
				
				if(type == 'button'){
					that.r_page = 1
				}
				
				let r_data = {
					limit: that.r_limit,
					page: that.r_page,
					account_role_type: ttt, // 表示广告主。ACCOUNT_ROLE_TYPE_AGENCY则是指-代理商
					
					admin_id: that.r_admin_id, // 负责人id
				}
				if(that.r_is_wechat_account){
					r_data.is_wechat_account = that.r_is_wechat_account // 2022-9-21一开始这里写的是固定值:0，但是现在改成这样
				}
				if(that.r_account_name){
					r_data.account_name = that.r_account_name // 账户名称
				}
				if(that.r_account_id){
					r_data.account_id = that.r_account_id // 代理商账户ID
				}
				if(type == '批量账户ID'){
					r_data.account_id = that.pl_text_content
				}
				accAgentList(r_data).then(res=>{
					console.log('授权列表',res);
					that.search_button_loading = false
					
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success('搜索成功');
						let data = res.data.data.data
						data.forEach(res=>{
							res.checked = false // 用于多选和单选
						})
						that.table_total = res.data.data.total
						that.tableShowData = data
						
						if(that.content_type == 2){
							that.rableTitle[9].show_control = true
						}
						else {
							that.rableTitle[9].show_control = false
						}
						
						that.checkAll = false
						that.indeterminate = false
						that.selectedData = []
					}
					else {
						
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`其他错误：${res.data.msg}`);
						}
					}
				})
			}
			else if(that.content_type == 1){
				accAgentAccountList({
					limit: that.d_limit,
					page: that.d_page,
				}).then(res=>{
					console.log("开发者",res);
					that.search_button_loading = false
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success('搜索成功');
						that.table_total_ddd = res.data.data.total
						that.tableShowDataDDD = res.data.data.data
					}
					else {
						
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`其他错误：${res.data.msg}`);
						}
					}
				})
			}
		},
		// 新增授权账户
		addButton(){
			let that = this
			this.$confirm({
			    title: '添加推广账户',
			    content: "点击确认打开新网页进行授权，授权成功后请刷新页面",
				okText: '确认',
				cancelText: '取消',
			    onOk() {
					// 这里用$http.excel_url可以，用$http.open_url也可以，后端那边写了域名跳转，跟我这里关系不大2022.9.21
			      window.open(`${that.$http.excel_url}api/adq/account-auth?id=1`)
			    },
			    onCancel() {
			      console.log('Cancel');
			    },
			});
		},
		// 分页
		paginationChange(e){
			let that = this
			
			if(that.content_type == 0 || that.content_type == 2){ // 推广账户管理
				that.r_page = e
			}
			else if(that.content_type == 1){ // 开发者账户管理
				that.d_page = e
			}
			
			that.searchButton()
			
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 选择负责人
		handleChangeD(e){
			this.edit_fzr = e
		},
		// 批量选择负责人
		handleChangeE(e){
			let ttt = true
			this.pl_select_admin.forEach(res=>{
				if(res.key == e.key){
					ttt = false
				}
			})
			if(ttt){
				this.pl_select_admin.push(e)
			}
		},
		// 显示编辑负责人弹窗
		editFZR(e){
			console.log(e);
			let arr = []
			for(let key in e.admin_user){
				// console.log(key)
				arr.push(key)
			}
			this.edit_fzr = arr
			// 改成新字段：admin_user，这里就废弃了
			// if(e.admin_id){
			// 	this.edit_fzr = e.admin_id.toString()
			// }
			// else {
			// 	this.edit_fzr = undefined
			// }
			this.e_ids = e.id
			this.edit_visible = true
		},
		// 编辑负责人弹窗
		editModalOk(){
			let that = this
			
			that.confirmLoading = true
			
			let arr = []
			arr.push(that.e_ids)
			accAgentEditFZR({
				admin_id: that.edit_fzr,
				ids: arr,
			}).then(res=>{
				that.confirmLoading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
					that.editModalCancel()
					that.$message.success('设置成功');
					console.log("编辑负责人弹窗",res);
					that.searchButton()
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		editModalCancel(){
			if(this.confirmLoading){
				return
			}
			this.edit_visible = false
		},
		
		// 同步代理商MP或者ADQ
		syncMpAdq(e){
			let that = this
			console.log(e);
			that.search_button_loading = true
			accAgentSyncMpAdq({
				id: e.id
			}).then(res=>{
				console.log("同步代理商MP或者ADQ",res);
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					
					that.$message.success(res.data.msg || '操作成功');
					
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
			
		},
		
		
		// 批量设置负责人部分
		// 批量设置负责人
		setFZR(){
			if(this.selectedData.length > 0){
				this.pl_modal = true
			}
			else {
				this.$message.warning('请先选择内容');
			}
		},
		// 全选
		onCheckAllChange(e){
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				
				
				that.selectedData = [] // 取消全选的时候，全部清除
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.selectedData.forEach(res_r => {
						if(res_r.id === res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.selectedData.push(res)
					}
				})
				
				that.indeterminate = false
				that.checkAll = true
				
			}
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.selectedData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.selectedData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.selectedData.length === 0){
					that.selectedData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.selectedData.length; i++){
						if(that.selectedData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.selectedData.push(that.tableShowData[index])
					}
				}
			}
			// that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.selectedData",that.selectedData)
			let ccc = true 
			let iii = false
			let nnn = that.selectedData.length || 0
			console.log("that.selectedData.length",that.selectedData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			
		},
		
		// 设置负责人
		setFZRShow(e){
			let that = this
			this.selectedData = []
			this.selectedData.push(e)
			console.log(e);
			e.auth.forEach(res=>{
				let obj = {
					label: res.admin_name,
					key: res.admin_id
				}
				this.pl_select_admin.push(obj)
			})
			this.pl_modal = true
		},
		
		// 批量设置负责人
		plOk(){
			let that = this
			if(that.pl_select_admin.length > 0){ // 得选择设置负责人
				that.pl_loading = true
				let a_data = []
				that.pl_select_admin.forEach(res=>{
					a_data.push(res.key)
				})
				console.log("a_data",a_data);
				
				let i_data = []
				that.selectedData.forEach(res=>{
					i_data.push(res.id)
				})
				console.log("i_data",i_data);
				
				accAgentEditFZR({
					admin_id: a_data,
					ids: i_data,
				}).then(res=>{
					that.pl_loading = false
					console.log("批量设置设置负责人",res);
					that.selectedData = []
					that.plCancel()
					that.$message.success('设置成功');
					that.searchButton()
				})
			}
			else {
				this.$message.warning('请先选择设置负责人');
			}
			
			
		},
		// 批量设置管理员弹窗取消按钮
		plCancel(){
			// if(this.pl_loading){
			// 	return 
			// }
			this.pl_modal = false
			this.pl_select_admin = []
			this.pl_loading = false
		},
		// 删除选择的负责人
		delSelectFZR(index){
			this.pl_select_admin.splice(index,1)
		},
		
		// 批量搜索账户ID
		showPlAccID(){
			this.$refs.refPlSearchID.plAccountID()
		},
		getPlId(ttt){
			this.pl_text_content = ttt
			this.searchButton('批量账户ID')
		}
	}
}	
</script>

<style>
</style>